import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '@/assets/images/logo-project-center-blanc.png'


const _hoisted_1 = {
  class: "nav-menu__wrapper",
  ref: "navMenuWrapper"
}
const _hoisted_2 = { class: "nav-menu__content-wrapper" }
const _hoisted_3 = { class: "nav-menu__content" }
const _hoisted_4 = { class: "nav-menu__icon-wrapper" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "nav-menu__sub-menu-content nav-menu__sub-menu-content--sublinks" }
const _hoisted_7 = {
  key: 0,
  class: "nav-menu__notification-icon"
}
const _hoisted_8 = { class: "nav-menu__secondary-links" }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = {
  key: 0,
  class: "nav-menu__secondary-link-label"
}
const _hoisted_11 = ["aria-label"]
const _hoisted_12 = {
  key: 0,
  class: "nav-menu__secondary-link-label"
}
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = {
  key: 0,
  class: "nav-menu__secondary-link-label"
}
const _hoisted_15 = ["aria-label"]
const _hoisted_16 = {
  key: 0,
  class: "nav-menu__secondary-link-label"
}
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = { class: "nav-menu__counter-sales" }
const _hoisted_19 = { class: "nav-menu__counter-sales-label" }
const _hoisted_20 = { class: "nav-menu__header" }
const _hoisted_21 = { class: "nav-menu__footer" }
const _hoisted_22 = { class: "nav-menu__sub-menu-content" }
const _hoisted_23 = { class: "nav-menu__sub-menu-content" }
const _hoisted_24 = { class: "nav-menu__sub-menu-content" }
const _hoisted_25 = {
  key: 0,
  class: "nav-menu__sub-menu-title"
}
const _hoisted_26 = { class: "nav-menu__sub-menu-content" }
const _hoisted_27 = { class: "nav-menu__sub-menu-content" }
const _hoisted_28 = { class: "nav-menu__sub-menu-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hadrianTooltip = _resolveComponent("hadrianTooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_iconQuickStartGuide = _resolveComponent("iconQuickStartGuide")!
  const _component_iconDocumentation = _resolveComponent("iconDocumentation")!
  const _component_iconChevron = _resolveComponent("iconChevron")!
  const _component_iconFeedback = _resolveComponent("iconFeedback")!
  const _component_iconLogOut = _resolveComponent("iconLogOut")!
  const _component_iconHelpBordered = _resolveComponent("iconHelpBordered")!
  const _component_helpBox = _resolveComponent("helpBox")!
  const _component_switchCheckbox = _resolveComponent("switchCheckbox")!
  const _component_iconStyleOptions = _resolveComponent("iconStyleOptions")!
  const _component_iconNavMenuChevron = _resolveComponent("iconNavMenuChevron")!
  const _component_feedbackModal = _resolveComponent("feedbackModal")!
  const _component_resourceCenterViewer = _resolveComponent("resourceCenterViewer")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nav-menu", { 'nav-menu--open': _ctx.isOpen }]),
    onMouseleave: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.removeSubMenus && _ctx.removeSubMenus(...args))),
    onScroll: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.removeSubMenus && _ctx.removeSubMenus(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("nav", _hoisted_3, [
          _createElementVNode("div", {
            class: "nav-menu__main-links",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeaveOrClick && _ctx.onMouseLeaveOrClick(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: item.label,
                to: _ctx.isClickable(item.url) ? item.url : '',
                disabled: !item.url || null,
                class: _normalizeClass(["nav-menu__main-link", {
                  'nav-menu__main-link--active': _ctx.isActive(item.url),
                  'nav-menu__main-link--disabled': !_ctx.isClickable(item.url),
                }]),
                onMouseenter: ($event: any) => (_ctx.onMouseEnter($event, item.label, !!item.subLinks)),
                onMouseleave: ($event: any) => (_ctx.onMouseLeaveOrClick($event, !!item.subLinks)),
                onFocus: ($event: any) => (_ctx.onMouseEnter($event, item.label, !!item.subLinks)),
                onBlur: ($event: any) => (_ctx.onMouseLeaveOrClick($event, !!item.subLinks))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: _normalizeClass({
                      'nav-menu__icon-notification':
                        _ctx.logoHasNotification(item.label) || _ctx.logoHasLeadAssignmentNotification(item.label),
                    })
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))
                    ], 2)
                  ]),
                  (_ctx.isOpen)
                    ? (_openBlock(), _createBlock(_component_hadrianTooltip, {
                        key: 0,
                        tooltipText: item.tooltip,
                        anchor: "left",
                        verticalPosition: "centered",
                        class: "nav-menu__main-link-label",
                        enabled: !!item.tooltip
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["tooltipText", "enabled"]))
                    : _createCommentVNode("", true),
                  (!!item.subLinks)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        id: `sub-menu-${item.label}`,
                        class: _normalizeClass(["nav-menu__main-link-sublinks nav-menu__sub-menu", { 'nav-menu__sub-menu--menu-is-open': _ctx.isOpen }])
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subLinks, (link) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                              to: `/${link.name}`,
                              key: link.name,
                              class: "nav-menu__sub-menu-item",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onMouseLeaveOrClick($event, true)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`mainMenu.menu.${link.name}`)) + " ", 1),
                                (_ctx.hasNewContent(link.name) || (link.name === 'tasks' && _ctx.hasUpcomingTaskNotifications))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t(`generic.new`)), 1))
                                  : _createCommentVNode("", true)
                              ], undefined, true),
                              _: 2
                            }, 1032, ["to"]))
                          }), 128))
                        ])
                      ], 10, _hoisted_5))
                    : _createCommentVNode("", true)
                ], undefined, true),
                _: 2
              }, 1032, ["to", "disabled", "class", "onMouseenter", "onMouseleave", "onFocus", "onBlur"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onQuickStartGuideClick && _ctx.onQuickStartGuideClick(...args))),
              class: "nav-menu__secondary-link",
              "aria-label": _ctx.$t('mainMenu.menu.quickStartGuide'),
              onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onMouseEnter($event, 'quick-start'))),
              onMouseleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeaveOrClick && _ctx.onMouseLeaveOrClick(...args))),
              onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onMouseEnter($event, 'quick-start'))),
              onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeaveOrClick && _ctx.onMouseLeaveOrClick(...args)))
            }, [
              _createVNode(_component_iconQuickStartGuide),
              (_ctx.isOpen)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('mainMenu.menu.quickStartGuide')), 1))
                : _createCommentVNode("", true)
            ], 40, _hoisted_9),
            _createElementVNode("button", {
              type: "button",
              class: "nav-menu__secondary-link",
              onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onMouseEnter($event, 'documentation', true))),
              onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onMouseLeaveOrClick($event, true))),
              onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onMouseEnter($event, 'documentation', true))),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onMouseEnter($event, 'documentation', true))),
              onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onMouseLeaveOrClick($event, true))),
              "aria-label": _ctx.$t('mainMenu.menu.documentation')
            }, [
              _createVNode(_component_iconDocumentation),
              (_ctx.isOpen)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('mainMenu.menu.documentation')), 1))
                : _createCommentVNode("", true),
              (_ctx.isOpen)
                ? (_openBlock(), _createBlock(_component_iconChevron, {
                    key: 1,
                    class: "nav-menu__secondary-link-chevron"
                  }))
                : _createCommentVNode("", true)
            ], 40, _hoisted_11),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onFeedBackClick && _ctx.onFeedBackClick(...args))),
              class: "nav-menu__secondary-link",
              "aria-label": _ctx.$t('mainMenu.menu.feedback'),
              onMouseenter: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onMouseEnter($event, 'feedback'))),
              onMouseleave: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeaveOrClick && _ctx.onMouseLeaveOrClick(...args))),
              onFocus: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onMouseEnter($event, 'feedback'))),
              onBlur: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeaveOrClick && _ctx.onMouseLeaveOrClick(...args)))
            }, [
              _createVNode(_component_iconFeedback),
              (_ctx.isOpen)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('mainMenu.menu.feedback')), 1))
                : _createCommentVNode("", true)
            ], 40, _hoisted_13),
            _createElementVNode("button", {
              type: "button",
              class: "nav-menu__secondary-link",
              "aria-label": _ctx.$t('mainMenu.menu.logout'),
              onMouseenter: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onMouseEnter($event, 'logout'))),
              onMouseleave: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeaveOrClick && _ctx.onMouseLeaveOrClick(...args))),
              onFocus: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onMouseEnter($event, 'logout'))),
              onBlur: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeaveOrClick && _ctx.onMouseLeaveOrClick(...args))),
              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.onLogOut && _ctx.onLogOut(...args)))
            }, [
              _createVNode(_component_iconLogOut),
              (_ctx.isOpen)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('mainMenu.menu.logout')), 1))
                : _createCommentVNode("", true)
            ], 40, _hoisted_15),
            _withDirectives(_createElementVNode("button", {
              type: "button",
              class: "nav-menu__secondary-link",
              "aria-label": _ctx.$t('mainMenu.help.title'),
              onMouseenter: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onMouseEnter($event, 'help'))),
              onMouseleave: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeaveOrClick && _ctx.onMouseLeaveOrClick(...args))),
              onFocus: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onMouseEnter($event, 'help'))),
              onBlur: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeaveOrClick && _ctx.onMouseLeaveOrClick(...args)))
            }, [
              _createVNode(_component_iconHelpBordered, { class: "nav-menu__help-icon" })
            ], 40, _hoisted_17), [
              [_vShow, !_ctx.isOpen]
            ])
          ]),
          _withDirectives(_createVNode(_component_helpBox, null, null, 512), [
            [_vShow, _ctx.isOpen]
          ]),
          _withDirectives(_createElementVNode("label", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('mainMenu.menu.counterSales')), 1),
            _createVNode(_component_switchCheckbox, {
              defaultValue: _ctx.isCounterSalesOn,
              onChange: _ctx.onCounterSalesToggle
            }, null, 8, ["defaultValue", "onChange"])
          ], 512), [
            [_vShow, _ctx.isOpen && _ctx.userCanAccessProjects]
          ]),
          _cache[43] || (_cache[43] = _createElementVNode("div", { class: "nav-menu__spacer" }, null, -1))
        ])
      ]),
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "nav-menu__drop-shadow",
            onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.onToggleIsNavMenuOpen && _ctx.onToggleIsNavMenuOpen(...args))),
            tabindex: "-1",
            "aria-label": "Toggle side nav menu"
          }))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("header", _hoisted_20, [
      _cache[44] || (_cache[44] = _createElementVNode("img", {
        class: "nav-menu__logo nav-menu__logo--open",
        src: _imports_0,
        alt: "Hadrian"
      }, null, -1)),
      _cache[45] || (_cache[45] = _createElementVNode("img", {
        class: "nav-menu__logo nav-menu__logo--closed",
        src: "/favicon.png",
        alt: "Hadrian"
      }, null, -1)),
      (_ctx.isProfilingEnabled && _ctx.isOpen)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "nav-menu__profiler-button",
            onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.onProfilerModalClick && _ctx.onProfilerModalClick(...args)))
          }, [
            _createVNode(_component_iconStyleOptions)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("footer", _hoisted_21, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.onToggleIsNavMenuOpen && _ctx.onToggleIsNavMenuOpen(...args))),
        class: "nav-menu__toggle-button"
      }, [
        _createVNode(_component_iconNavMenuChevron)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        key: item.label,
        to: item.url || '',
        disabled: !item.url || null,
        class: _normalizeClass(["nav-menu__sub-menu", { 'nav-menu__sub-menu--disabled': !item.url }]),
        id: `sub-menu-${item.label}`,
        onMouseleave: _ctx.onMouseLeaveOrClick
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_22, _toDisplayString(item.label), 1)
        ], undefined, true),
        _: 2
      }, 1032, ["to", "disabled", "class", "id", "onMouseleave"]))
    }), 128)),
    _createElementVNode("a", {
      href: "https://project-center-next-assets.s3.us-east-2.amazonaws.com/Next+Quick+Start+Guide+2.pdf",
      target: "_blank",
      class: "nav-menu__sub-menu",
      id: "sub-menu-quick-start",
      onMouseleave: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeaveOrClick && _ctx.onMouseLeaveOrClick(...args))),
      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.removeSubMenus(true)))
    }, [
      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('mainMenu.menu.quickStartGuide')), 1)
    ], 32),
    _createElementVNode("div", {
      class: _normalizeClass(["nav-menu__sub-menu", { 'nav-menu__sub-menu--menu-is-open': _ctx.isOpen }]),
      id: "sub-menu-documentation",
      onMouseleave: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeaveOrClick && _ctx.onMouseLeaveOrClick(...args)))
    }, [
      _createElementVNode("div", _hoisted_24, [
        (!_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('mainMenu.menu.documentation')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "nav-menu__sub-menu-item",
          onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.onResourceCenterClick && _ctx.onResourceCenterClick(...args)))
        }, _toDisplayString(_ctx.$t('mainMenu.menu.documentationItems.resourceCenter')), 1),
        _createVNode(_component_router_link, {
          class: "nav-menu__sub-menu-item",
          to: _ctx.RouterPaths.unauthenticatedTermsConditions,
          target: "_blank",
          onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.removeSubMenus(true)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('mainMenu.menu.documentationItems.licenseAgreement')), 1)
          ], undefined, true),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          class: "nav-menu__sub-menu-item",
          to: _ctx.RouterPaths.unauthenticatedPrivacyPolicy,
          target: "_blank",
          onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.removeSubMenus(true)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('mainMenu.menu.documentationItems.privacyPolicy')), 1)
          ], undefined, true),
          _: 1
        }, 8, ["to"]),
        (_ctx.isResourceCenterAdmin)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: "nav-menu__sub-menu-item",
              to: _ctx.RouterPaths.resourceAdmin,
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.removeSubMenus(true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('mainMenu.menu.documentationItems.resourceAdmin')), 1)
              ], undefined, true),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ])
    ], 34),
    _createElementVNode("button", {
      type: "button",
      class: "nav-menu__sub-menu",
      id: "sub-menu-feedback",
      onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.onFeedBackClick && _ctx.onFeedBackClick(...args))),
      onMouseleave: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeaveOrClick && _ctx.onMouseLeaveOrClick(...args)))
    }, [
      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('mainMenu.menu.feedback')), 1)
    ], 32),
    _createElementVNode("button", {
      type: "button",
      class: "nav-menu__sub-menu",
      id: "sub-menu-logout",
      onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.onLogOut && _ctx.onLogOut(...args))),
      onMouseleave: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeaveOrClick && _ctx.onMouseLeaveOrClick(...args)))
    }, [
      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('mainMenu.menu.logout')), 1)
    ], 32),
    _createElementVNode("div", {
      class: "nav-menu__sub-menu",
      id: "sub-menu-help",
      onMouseleave: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeaveOrClick && _ctx.onMouseLeaveOrClick(...args)))
    }, [
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_helpBox)
      ])
    ], 32),
    _createVNode(_component_feedbackModal),
    _createVNode(_component_resourceCenterViewer)
  ], 34)), [
    [_directive_click_outside, _ctx.removeSubMenus]
  ])
}